<div
  class="bg-[#FCEDCD] flex flex-col lg:flex-row lg:justify-around items-start lg:items-center w-full pt-[16px] pb-[10px] relative px-[20px] lg:px-0"
>
  <div class="flex items-center md:mb-2">
    <div>
      <div class="font-bold text-[14px] md:text-lg text-[#0A2259]">
        Delivery Window Closed
      </div>
      <div
        class="text-black-color text-[12px] md:text-[14px] max-w-[200px] md:max-w-full"
      >
        We'll resume at
        <span class="text-[#FF4D23] font-semibold">{{
          this._data?.openTime | date : "shortTime"
        }}</span
        >. You can still schedule your delivery now
      </div>
    </div>
  </div>
  <div class="flex justify-between items-center gap-[100px] relative">
    <p
      class="text-black-color text-[12px] md:text-[14px] font-medium mr-[30px] xl:mr-0"
    >
      Thank You for your patience!
    </p>
    <img
      src="assets/images/ui/deliveryMethod.svg"
      class="absolute -top-[90px] lg:-top-[73px] -right-[145px] md:-right-[450px] lg:-right-[65px] xl:-right-[90px] w-auto h-[120px] z-10"
      alt="Closed"
    />
  </div>

  <button
    mat-icon-button
    class="!absolute !top-0 !right-0"
    (click)="this._bottomSheetRef.dismiss()"
  >
    <mat-icon class="text-orange-color text-xl">close</mat-icon>
  </button>
</div>
